import { ApiHelper } from 'api';
import { getGatewayUrl } from 'shared/api/urls';
import {
  SEND_EMAIL_OTP,
  RESEND_EMAIL_OTP,
  VERIFY_EMAIL_OTP,
} from 'User/constants/emailVerification/url';
import {
  SendEmailOtpRequestParams,
  SendMappingOTPResponse,
} from 'User/types/emailVerification';
import {
  SEND_MAPPING_OTP_API_ERROR,
  VERIFY_MAPPING_OTP_API_ERROR,
} from 'User/store/emailVerification/constants/errorMessages';
import { logErrors } from 'helpers/utils/logErrors';
import { VerifyMappingOtpResponse } from 'User/types/emailVerification';

import { transformSendMappingOtp } from './transformers/sendMappingOtp';
import { transformVerifyMappingOtp } from './transformers/verifyMappingOtp';


export const sendEmailOtp = async (params: SendEmailOtpRequestParams): Promise<SendMappingOTPResponse> => {
  try {
    const url = `${getGatewayUrl()}${SEND_EMAIL_OTP}`;
    const {
      email,
    } = params;
    const queryParams = {
      email,
      'domain': 'nykaa',
      'source': 'react',
    };
    const { data } = await ApiHelper(url, 'POST', params = { ...queryParams });
    // transform response;
    const transformedResponse = transformSendMappingOtp(null, data);

    return transformedResponse;
  } catch (error) {
    // Handle Network Error
    const customMessage = SEND_MAPPING_OTP_API_ERROR;
    logErrors(error, customMessage);
    const transformedResponse = transformSendMappingOtp(error, null);
    return transformedResponse;
  }
};

export const resendEmailOtp = async (params: SendEmailOtpRequestParams): Promise<SendMappingOTPResponse> => {
  try {
    const url = `${getGatewayUrl()}${RESEND_EMAIL_OTP}`;
    const {
      otpId,
    } = params;
    const queryParams = {
      otp_id: otpId,
      domain: __PLATFORM__,
      source: 'react',
    };

    const { data } = await ApiHelper(url, 'POST', params = queryParams);
    // transform response;
    const transformedResponse = transformSendMappingOtp(null, data);

    return transformedResponse;
  } catch (error) {
    // Handle Network Error
    const customMessage = SEND_MAPPING_OTP_API_ERROR;
    logErrors(error, customMessage);
    const transformedResponse = transformSendMappingOtp(error, null);
    return transformedResponse;
  }
};


export const verifyMappingOtp = async (params: UserDefinedObject): Promise<VerifyMappingOtpResponse> => {
  try {
    const url = `${getGatewayUrl()}${VERIFY_EMAIL_OTP}`;
    const {
      otp,
      otpId,
    } = params;
    const queryParams = {
      otp_id: otpId,
      otp,
      domain: 'nykaa',
      source: 'react',
    };

    const { data } = await ApiHelper(url, 'POST', queryParams);
    const transformedResponse = transformVerifyMappingOtp(null, data);

    return transformedResponse;
  } catch (error) {
    const customMessage = VERIFY_MAPPING_OTP_API_ERROR;
    logErrors(error, customMessage);

    const transformedResponse = transformVerifyMappingOtp(error, null);
    return transformedResponse;
  }
};
